export const RequestActionTypes = {
    LOGOUT: 'LOGOUT',

    CREATE_REQUEST_REQ: 'CREATE_REQUEST_REQ',
    CREATE_REQUEST_REQ_SUCCESS: 'CREATE_REQUEST_REQ_SUCCESS',
    CREATE_REQUEST_REQ_ERROR: 'CREATE_REQUEST_REQ_ERROR',
    CREATE_REQUEST_REQ_STATUS: 'CREATE_REQUEST_REQ_STATUS',

    UPDATE_REQUEST_STATUS_REQ: 'UPDATE_REQUEST_STATUS_REQ',
    UPDATE_REQUEST_STATUS_REQ_SUCCESS: 'UPDATE_REQUEST_STATUS_REQ_SUCCESS',
    UPDATE_REQUEST_STATUS_REQ_ERROR: 'UPDATE_REQUEST_STATUS_REQ_ERROR',
    UPDATE_REQUEST_STATUS_REQ_STATUS: 'UPDATE_REQUEST_STATUS_REQ_STATUS',

    REQUEST_LIST_REQ: 'REQUEST_LIST_REQ',
    REQUEST_LIST_REQ_SUCCESS: 'REQUEST_LIST_REQ_SUCCESS',
    REQUEST_LIST_REQ_ERROR: 'REQUEST_LIST_REQ_ERROR',

    REQUEST_DETAIL_REQ: 'REQUEST_DETAIL_REQ',
    REQUEST_DETAIL_REQ_SUCCESS: 'REQUEST_DETAIL_REQ_SUCCESS',
    REQUEST_DETAIL_REQ_ERROR: 'REQUEST_DETAIL_REQ_ERROR'
}
